import { token } from "../../../../theme";

interface EmbeddedBrowserProps {
  link: string;
  width?: string;
  height?: string;
}

const EmbeddedBrowser = ({
  link,
  width = "100%",
  height = "600px",
}: EmbeddedBrowserProps) => {
  return (
    <div
      style={{
        width,
        height,
        resize: "both",
        overflow: "hidden",

        boxShadow: token.invertedStandardBoxShadow,
        padding: "4px",
      }}
    >
      <iframe
        src={link}
        title="Embedded Browser"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default EmbeddedBrowser;
